export const BACKGROUND_COLOR_TYPES = {
    SOLID: 'solid',
    ANIMATION: 'animation',
    GRADIENT: 'gradient',
}